<template>
  <div>
    <!-- 搜索表单区域 -->
    <el-form :model="query" label-width="125px" inline size="mini">
      <el-form-item label="支付订单号">
        <el-input v-model="query.payOrderUuid" clearable placeholder="请输入支付订单号"></el-input>
      </el-form-item>
      <el-form-item label="用户信息">
        <el-input v-model="query.user" clearable placeholder="请输入用户信息"></el-input>
      </el-form-item>
      <el-form-item label="支付渠道">
        <el-select v-model="query.channel" clearable placeholder="请选择支付渠道">
          <el-option label="微信支付分" value="3"></el-option>
          <el-option label="支付宝预授权" value="4"></el-option>
        </el-select>
      </el-form-item>
      <!-- 创建起始时间段 -->
      <el-form-item label="创建时间段">
        <el-date-picker
          v-model="ctPeriod"
          value-format="yyyy-MM-dd"
          unlink-panels
          type="daterange"
          range-separator="至"
          start-placeholder="创建使用起始时间"
          end-placeholder="创建使用结束时间"
        ></el-date-picker>
      </el-form-item>
      <!-- 创建结束时间段 -->
      <!-- <el-form-item label="完结时间段">
        <el-date-picker
          v-model="ptPeriod"
          value-format="yyyy-MM-dd"
          unlink-panels
          type="daterange"
          range-separator="至"
          start-placeholder="完结起始时间"
          end-placeholder="完结结束时间"
        ></el-date-picker>
      </el-form-item> -->
      <el-button type="primary" size="mini" @click="seach">搜索</el-button>
    </el-form>
    <!-- 卡片视图区域 -->
    <el-card>
      <!-- 表格数据展示区域 -->
      <el-table :data="authList" style="width: 100%" height="650px" border="" stripe>
        <!-- 展开行区域 -->
        <el-table-column type="expand">
          <template slot-scope="scope">
            <el-form label-width="80px" label-position="left" inline class="expand">
              <el-form-item label="用户ID">
                <span>{{ scope.row.userUuid }}</span>
              </el-form-item>
              <el-form-item label="用户昵称">
                <span>{{ scope.row.userName }}</span>
              </el-form-item>
              <el-form-item label="用户手机">
                <span>{{ scope.row.userCellphone }}</span>
              </el-form-item>
              <el-form-item label="创建时间">
                <span>{{ scope.row.createTime }}</span>
              </el-form-item>
              <el-form-item label="冻结金额">
                <span>{{ scope.row.freezeAmount }}元</span>
              </el-form-item>
              <el-form-item label="冻结时间">
                <span>{{ scope.row.freezeTime }}</span>
              </el-form-item>
              <el-form-item label="授权号">
                <span>{{ scope.row.authNo }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="uuid" label="订单号" width="240"></el-table-column>
        <el-table-column label="类型" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.type === 1">押金充值</span>
            <span v-else-if="scope.row.type === 2">余额充值</span>
            <span v-else-if="scope.row.type === 3">预约订单</span>
            <span v-else-if="scope.row.type === 11">信用订单</span>
            <span v-else-if="scope.row.type === 4">余额支付</span>
          </template>
        </el-table-column>
        <el-table-column label="支付渠道" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.channel === 1">微信</span>
            <span v-else-if="scope.row.channel === 2">支付宝</span>
            <span v-else-if="scope.row.channel === 3">微信支付分</span>
            <span v-else-if="scope.row.channel === 4">支付宝预授权</span>
            <span v-else-if="scope.row.channel === 11">微信余额</span>
            <span v-else-if="scope.row.channel === 12">支付宝余额</span>
          </template>
        </el-table-column>
        <el-table-column prop="freezeAmount" label="冻结金额/元" align="right"></el-table-column>
        <el-table-column prop="amount" label="支付金额/元" align="right"></el-table-column>
        <el-table-column label="授权类型">
          <template slot-scope="scope">
            <span v-if="scope.row.authType === 1">信用</span>
            <span v-else>资金</span>
          </template>
        </el-table-column>
        <el-table-column label="订单状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.status === 0">新建订单</el-tag>
            <el-tag v-if="scope.row.status === 1" type="success">支付成功</el-tag>
            <el-tag v-if="scope.row.status === 2" type="danger">支付失败</el-tag>
            <el-tag v-if="scope.row.status === 3" type="info">取消支付</el-tag>
            <el-tag v-if="scope.row.status === 4" type="warning">申请退款</el-tag>
            <el-tag v-if="scope.row.status === 5" type="success">退款成功</el-tag>
            <el-tag v-if="scope.row.status === 6" type="danger">退款失败</el-tag>
            <el-tag v-if="scope.row.status === 7" type="info">取消退款</el-tag>
            <el-tag v-if="scope.row.status === 8">全额抵扣</el-tag>
            <el-tag v-if="scope.row.status === 11" type="success">冻结成功</el-tag>
            <el-tag v-if="scope.row.status === 12" type="success">解冻成功</el-tag>
            <el-tag v-if="scope.row.status === 13" type="danger">冻结失败</el-tag>
            <el-tag v-if="scope.row.status === 14" type="info">取消冻结</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="资金状态">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.authState === 1" type="danger">冻结</el-tag>
            <el-tag v-else-if="scope.row.authState === 2" type="success">解冻</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="endOrder(scope.row.uuid)">完结订单</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页区域 -->
      <el-pagination
        @size-change="pageSizeChange"
        @current-change="CurrentPageChange"
        :current-page="query.curPage"
        :page-sizes="[5, 10, 15]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </el-card>
  </div>
</template>

<script>
import { authList, endAuth } from '@/API/order'
export default {
  name: 'auth',
  data() {
    return {
      query: {
        pageSize: 10,
        curPage: 1,
        ctStart: '',
        ctEnd: '',
        ptStart: '',
        ptEnd: ''
      },
      // 创建起始时间段
      ctPeriod: [],
      // 创建结束时间段
      ptPeriod: [],
      total: 0,
      authList: []
    }
  },
  mounted() {
    this.getAuth()
  },
  methods: {
    async getAuth() {
      this.authList = []
      const { data: res } = await authList(this.query)
      if (res.code !== 200) return this.$message.error(res.message)
      this.authList = res.data.entities
      this.total = res.data.totalSize
    },
    seach() {
      this.query.curPage = 1
      if (this.ctPeriod != null && this.ctPeriod !== []) {
        this.query.ctStart = this.ctPeriod[0]
        this.query.ctEnd = this.ctPeriod[1]
      } else {
        this.query.ctStart = ''
        this.query.ctEnd = ''
      }
      if (this.ptPeriod != null && this.ptPeriod !== []) {
        this.query.ptStart = this.ptPeriod[0]
        this.query.ptEnd = this.ptPeriod[1]
      } else {
        this.query.ptStart = ''
        this.query.ptEnd = ''
      }
      this.getAuth()
    },
    // 监听pageSize
    pageSizeChange(newSize) {
      this.query.pageSize = newSize
      this.getAuth()
    },
    // 监听curPage
    CurrentPageChange(newPage) {
      this.query.curPage = newPage
      this.getAuth()
    },
    async endOrder(orderId) {
      const { data: res } = await endAuth({ orderId })
      if (res.code !== 200) return this.$message.error(res.message)
      this.$message.success(res.message)
    }
  }
}
</script>

<style lang="less" scoped>
.el-pagination {
  margin-top: 30px;
}
.expand {
  .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 33%;
  }
}
</style>
